export enum PerfilEnum {
	SEDE = 'SEDE',
	FRANQUIA = 'FRANQUIA',
}
